import React from 'react';
import { StyleSheet, View } from 'react-native';

import { theme } from '@garnish/constants';
import { AnimatedViews, useResponsive } from '@garnish/core';

// ─────────────────────────────────────────────────────────────────────────────

export const IdMeVerificationLoading = () => {
  const { match } = useResponsive();

  // ─── Styles ────────────────────────────────────────────────────────────────

  const containerStyles = match([styles.containerXS, styles.containerSM]);
  const contentStyles = [styles.content, match([styles.contentXS, styles.contentSM])];
  const descriptionStyles = match([styles.descriptionXS, styles.descriptionSM]);
  const actionsStyles = match([styles.actionsXS, styles.actionsSM]);
  const verifyButtonStyles = match([styles.buttonXS, styles.verifyButtonSM]);
  const learnMoreButtonStyles = match([styles.buttonXS, styles.learnMoreButtonSM]);

  // ───────────────────────────────────────────────────────────────────────────

  return (
    <View style={containerStyles}>
      <View style={contentStyles}>
        <AnimatedViews.Pulse style={styles.logoRow} />

        <AnimatedViews.Pulse index={1} style={descriptionStyles}>
          <View style={styles.descriptionLineFull} />
          <View style={styles.descriptionLineLong} />
          <View style={styles.descriptionLineShort} />
        </AnimatedViews.Pulse>
      </View>

      <View style={actionsStyles}>
        <AnimatedViews.Pulse index={2} style={verifyButtonStyles} />

        <AnimatedViews.Pulse index={3} style={learnMoreButtonStyles} />
      </View>
    </View>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  containerXS: {
    flexGrow: 1,
    gap: theme.spacing['10'],
    paddingTop: theme.spacing['4'],
  },
  containerSM: {
    gap: theme.spacing['8'],
  },
  content: {
    gap: theme.spacing['4'],
  },
  contentXS: {
    flexGrow: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },
  contentSM: {
    paddingHorizontal: theme.spacing['4'],
  },
  logoRow: {
    width: 190,
    height: 32,
    marginVertical: 14,
    borderRadius: theme.radius.small,
    backgroundColor: theme.colors.OPACITY.DARK_KALE.LIGHTEST,
  },
  descriptionXS: {
    alignSelf: 'stretch',
    alignItems: 'center',
  },
  descriptionSM: {
    alignSelf: 'stretch',
  },
  descriptionLineFull: {
    width: '100%',
    height: 16,
    marginVertical: 4,
    borderRadius: theme.radius.small,
    backgroundColor: theme.colors.OPACITY.DARK_KALE.LIGHTEST,
  },
  descriptionLineLong: {
    width: '90%',
    height: 16,
    marginVertical: 4,
    borderRadius: theme.radius.small,
    backgroundColor: theme.colors.OPACITY.DARK_KALE.LIGHTEST,
  },
  descriptionLineShort: {
    width: '45%',
    height: 16,
    marginVertical: 4,
    borderRadius: theme.radius.small,
    backgroundColor: theme.colors.OPACITY.DARK_KALE.LIGHTEST,
  },
  actionsXS: {
    gap: theme.spacing['2'],
    paddingHorizontal: theme.spacing['6'],
    marginBottom: theme.spacing['6'],
  },
  actionsSM: {
    flexDirection: 'row',
    gap: theme.spacing['4'],
  },
  buttonXS: {
    height: 64,
    borderRadius: theme.radius['3xLarge'],
    backgroundColor: theme.colors.OPACITY.DARK_KALE.LIGHTEST,
  },
  verifyButtonSM: {
    width: 251,
    height: 64,
    borderRadius: theme.radius['3xLarge'],
    backgroundColor: theme.colors.OPACITY.DARK_KALE.LIGHTEST,
  },
  learnMoreButtonSM: {
    width: 152,
    height: 64,
    borderRadius: theme.radius['3xLarge'],
    backgroundColor: theme.colors.OPACITY.DARK_KALE.LIGHTEST,
  },
});
